import { Suspense } from "react";
import { RouteObject } from "react-router";

import * as Sentry from "@sentry/react";

import PageError from "@/helpers/components/Errors/PageError";
import Spinner from "@/helpers/components/Spinner";

export const MeasurementsRoutes: RouteObject = {
	path: "/measurements/*",
	children: [
		{
			index: true,
			lazy: async () => {
				const { MeasurementsHomePage } = await import(
					"@/components/Measurements/Pages/MeasurementsHomePage"
				);
				return {
					Component: (props: {}) => (
						<Sentry.ErrorBoundary
							fallback={({ error, componentStack, resetError }) => (
								<PageError
									error={error}
									componentStack={componentStack}
									reset={resetError}
								/>
							)}
						>
							<Suspense
								fallback={<Spinner text="Loading Measurements Home Page" />}
							>
								<MeasurementsHomePage {...props} />
							</Suspense>
						</Sentry.ErrorBoundary>
					),
					ErrorBoundary: () => <div>Error loading MeasurementsHomePage</div>,
				};
			},
		},
	],
};
